import React, { useState } from "react"
import insideCountries from "../images/insidecountries.jpg"
import democratsAndAutocrats from "../images/democratsandautocrats.jpg"

const bookData = [
  {
    id: "left",
    image: insideCountries,
    title: "Inside Countries",
    year: "2019 · Cambridge University Press",
    text: "Although comparative politics is traditionally understood as the study of politics across countries, the field has a longstanding — and increasingly influential — tradition of examining politics within countries, focusing on subnational units, institutions, actors, and processes. This book provides the first comprehensive assessment of the substantive, theoretical, and methodological contributions of this subnational turn in comparative politics.",
    amazon: "https://www.amazon.com/Inside-Countries-Subnational-Research-Comparative/dp/1108721702",
    publisher: "https://www.cambridge.org/core/books/abs/inside-countries/inside-countries/03B342595A8F891B4691BAA9797A9DCC",
  },
  {
    id: "right",
    image: democratsAndAutocrats,
    title: "Democrats and Autocrats",
    year: "2015 · Oxford University Press",
    text: "Even though many Latin American countries transitioned to democracy, large segments of their populations — particularly those living in peripheral regions — continue to experience undemocratic rule. This book examines the persistence of subnational undemocratic regimes in Argentina and Mexico, identifying multiple within-country trajectories that explain how and why such regimes are reproduced.",
    amazon: "https://www.amazon.com/Democrats-Autocrats-Subnational-Undemocratic-Transformations/dp/0198706863",
    publisher: "https://global.oup.com/academic/product/democrats-and-autocrats-9780198706861",
  },
]

export default function Books() {
  const [active, setActive] = useState("left")

  return (
    <div style={wrap} id="books">
      <div style={inner} className="ag-inner">
        <h2 style={titleStyle}>Books</h2>
        <div style={grid} className="books-grid-inner">
          {bookData.map(b => (
            <div
              key={b.id}
              role="button"
              tabIndex={0}
              onClick={() => setActive(b.id)}
              onKeyDown={e => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault()
                  setActive(b.id)
                }
              }}
              className="book-card-inner"
              style={{ ...card, ...(active === b.id ? cardActive : {}) }}
            >
              <div style={coverWrap}>
                <img src={b.image} alt={b.title} style={coverStyle} />
              </div>
              <div>
                <p style={cardTitle}>{b.title}</p>
                <p style={cardYear}>{b.year}</p>
                <p style={cardText} className="book-card-text">{b.text}</p>
                <div style={linksRow}>
                  <a href={b.amazon} target="_blank" rel="noreferrer" style={bookLink}>Amazon</a>
                  <a href={b.publisher} target="_blank" rel="noreferrer" style={bookLink}>Publisher</a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <style>{`
        @media (max-width: 900px) {
          .books-grid-inner { grid-template-columns: 1fr !important; }
          .book-card-inner { grid-template-columns: 120px 1fr !important; }
        }
        @media (max-width: 480px) {
          .book-card-inner { grid-template-columns: 1fr !important; }
        }
        @media (max-width: 600px) {
          .book-card-text { text-align: justify !important; }
        }
      `}</style>
    </div>
  )
}

const wrap = {
  background: "var(--cobalt)",
  padding: "96px 0",
}

const inner = {
  maxWidth: "1320px",
  margin: "0 auto",
  padding: "0 40px",
}

const titleStyle = {
  fontFamily: '"Avant Garde", sans-serif',
  fontWeight: 300,
  fontSize: "32px",
  letterSpacing: "0.04em",
  color: "white",
  marginBottom: "56px",
}

const grid = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "48px",
}

const card = {
  display: "grid",
  gridTemplateColumns: "160px 1fr",
  gap: "32px",
  cursor: "pointer",
  padding: "32px",
  border: "1px solid rgba(255,255,255,0.1)",
  transition: "all 0.3s",
}

const cardActive = {
  borderColor: "var(--gold)",
  background: "rgba(255,255,255,0.04)",
}

const coverWrap = {
  position: "relative",
}

const coverStyle = {
  width: "100%",
  aspectRatio: "2/3",
  objectFit: "cover",
  display: "block",
  boxShadow: "6px 6px 24px rgba(0,0,0,0.4)",
  marginBottom: 0,
}

const cardTitle = {
  fontFamily: '"Avant Garde", sans-serif',
  fontWeight: 600,
  fontSize: "15px",
  letterSpacing: "0.04em",
  color: "white",
  marginBottom: "8px",
  lineHeight: 1.3,
}

const cardYear = {
  fontFamily: '"Avant Garde", sans-serif',
  fontSize: "11px",
  letterSpacing: "0.1em",
  color: "var(--gold)",
  marginBottom: "16px",
}

const cardText = {
  fontSize: "16px",
  lineHeight: 1.65,
  color: "rgba(255,255,255,0.72)",
  marginBottom: "24px",
}

const linksRow = {
  display: "flex",
  gap: "12px",
  flexWrap: "wrap",
}

const bookLink = {
  fontFamily: '"Avant Garde", sans-serif',
  fontSize: "10px",
  letterSpacing: "0.16em",
  textTransform: "uppercase",
  color: "white",
  border: "1px solid rgba(255,255,255,0.3)",
  padding: "7px 16px",
  textDecoration: "none",
  transition: "all 0.2s",
}
